import {NotificationType, TransactionEventTypes, transactionNotificationPrefix} from '@wallex-core-client/core/constants/notification.constants';

export const isTransactionEventNotification = (notificationType: NotificationType): boolean =>
  TransactionEventTypes.includes(notificationType) || notificationType.split('.')[0] === transactionNotificationPrefix;

export const areNotificationsSupported = () => 'Notification' in window && 'serviceWorker' in navigator;
